// extracted by mini-css-extract-plugin
module.exports = {"aboutPage":"aboutPage__1GCmi","aboutText":"aboutText__2ZpCf","logosContainer":"logosContainer__2NW5Q"};